import axiosClient from "api/axiosClient";

const BASE_URL = "/person";

const personService = {
    get(id) {
        return axiosClient.get(`${BASE_URL}/${id}`);
    },

    create(data) {
        return axiosClient.post(BASE_URL, data);
    },

    update(id, data) {
        return axiosClient.patch(`${BASE_URL}/${id}`, data);
    },

    delete(id) {
        return axiosClient.delete(`${BASE_URL}/${id}`);
    },
    list() {
        return axiosClient.get(BASE_URL);
    }
};

export default personService;
